import React, { useEffect, useState } from 'react';
import { FormGroup, FormCheckbox } from 'shards-react';
import useLocales from '../../hooks/useLocales';
import type { OptionsType } from '../../types/options';
const namePrefix: string = 'optionsType';

type MyOptionsType<T> = Omit<OptionsType, 'code'> & {
  code: T;
};

interface OptionsTypeCheckboxProps<T> {
  label?: string;
  options: MyOptionsType<T>[];
  selectedCodes: T[];
  onChangeChecked?: (codes: T[]) => void;
}

const OptionsTypeCheckboxes = <T,>({ label = '', options, selectedCodes, onChangeChecked = (): void => {} }: OptionsTypeCheckboxProps<T>): JSX.Element => {
  const { currentLang } = useLocales();
  const [selected, setSelected] = useState<T[]>(selectedCodes);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  //   console.log(selected);
  // }, [selected]);

  // EVENT HANDLER
  // ================================================================================

  const handleToggleChecked = (event: React.MouseEvent<HTMLDivElement>): void => {
    // Shardsはチェックボックスを疑似要素（:before）で実装しているため
    // （labelではなく）チェックボックス自体をクリックするとevent.currentTargetがundefinedになる。
    // そこで実際のチェックボックスinputを捕捉するためにチェックボックスをdivでラップし、
    // divのイベントハンドラーでevent.targetから要素を判定してチェックボックスinputをゲットする。
    //
    // チェックボックスをクリックした場合のevent.targetは、
    // <span class="custom-control-description">
    // <input id="optionsTypeNIPPONSTEEL" class="custom-control-input" name="NIPPONSTEEL" type="checkbox" checked="">
    //
    // ラベルをクリックした場合のevent.targetは、
    // <label id="optionsTypeNIPPONSTEEL" class="custom-control-label" aria-hidden="true">
    //
    // なので、event.targetがinputかlabelのとき、そのidから値を取得する。
    //
    // ただしFormCheckboxコンポーネント自体がlabelタグで実装されているので
    // クリックした座標次第で（チェックボックスでもラベル文字列でもない）FormCheckbox自体が
    // event.targetとして捕捉される可能性もあるためidの有無もチェックする必要がある

    // console.log(event.target);
    const target: unknown = event.target;
    if (target instanceof HTMLInputElement || (target instanceof HTMLLabelElement && target.id)) {
      const code: T = target.id.split(namePrefix)[1] as unknown as T;
      // console.log(code);
      // Toggle処理
      // codeがselectedにあれば削除、なければ追加
      const isExist: boolean = selected.includes(code);
      const newSelected: T[] = isExist ? [...selected].filter((item) => item !== code) : [...selected, code];
      setSelected(newSelected);
      onChangeChecked(newSelected);
    } else {
      // do nothing
    }
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <FormGroup>
        {label.length && <strong className="text-muted d-block">{label}</strong>}
        {options.map((option, index) => {
          return (
            <div key={'options-type-' + index} onClick={handleToggleChecked}>
              <FormCheckbox id={namePrefix + option.code} name={namePrefix + option.code} checked={selected.includes(option.code)}>
                {currentLang.value === 'ja' ? option.nameJapanese : option.nameEnglish ?? option.nameJapanese}
              </FormCheckbox>
            </div>
          );
        })}
      </FormGroup>
    </>
  );
};

export default OptionsTypeCheckboxes;
